import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import { CategoryContainer, CategoryHeading } from './Category.styles';
import { Slider } from '@/components/ReactSlickCarousel';
import { deviceWidth } from '@/utils/deviceWidth';
import { ProductListWrapper } from '../../Widgets2.0/ProductListWrapper';
import { getHeroBannerHeightCalculation } from 'src/redux/actions';

const Category = (props) => {
  const router = useRouter();

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getHeroBannerHeightCalculation());
  }, []);

  const {
    catalogData: { categories },
    commonData: {
      heightCalculation: { heroBannerHeightCalculated },
    },
  } = useSelector((state: any) => ({
    catalogData: state.catalogReducer,
    commonData: state.commonReducer,
  }));

  const settings = {
    dots: false,
    // centerMode: true,
    infinite: false,
    slidesToShow: deviceWidth < 766 ? 1 : 3,
    slidesToScroll: 1,
    speed: 500,
  };

  // const onItemsImageClick = async (item) => {
  //   const util = await import('@/utils/routes');
  //   const { getRoute, PATH } = util;

  //   const route = getRoute(
  //     PATH.productDescription(
  //       item.id,
  //       item.name.replace(/[&\/\\#, +()$~%.'":*?<>{}\n]/g, '-')
  //     ),
  //     store_info?.domain
  //   );

  //   router.push(route);
  // };

  return (
    (heroBannerHeightCalculated || router.route.includes('shop')) && (
      <CategoryContainer>
        <CategoryHeading>Collections</CategoryHeading>
        <Slider {...settings}>
          <ProductListWrapper
            productList={categories}
            oldCardConfigs={{
              showButton: props.showATCBtn,
              showCategoryCard: true,
            }}
          />
        </Slider>
      </CategoryContainer>
    )
  );
};

export default Category;
